import { styled } from '@aibi-ui/core';
import React, { ChangeEventHandler, useEffect, useState } from 'react';
import { Input } from 'src/components/Input';

import aiManageRoutes from 'src/pages/Backstage/routes/modules/ai-manage';
import baseRoutes from 'src/pages/Backstage/routes/modules/base';
import dataSourceRoutes from 'src/pages/Backstage/routes/modules/data-source';
// import logRoutes from 'src/pages/Backstage/routes/modules/log';
import userPermissionRoutes from 'src/pages/Backstage/routes/modules/user-permission';
import dataPermissionRoutes from 'src/pages/Backstage/routes/modules/data-permission';

import ImgBackground from 'src/assets/images/backstage/search-page-panel/background.png';
import IconUserPermission from 'src/assets/images/backstage/search-page-panel/user-permission.png';
import IconDataPermission from 'src/assets/images/backstage/search-page-panel/data-permission.png';
// import IconLog from 'src/assets/images/backstage/search-page-panel/log.png';
import IconDataSource from 'src/assets/images/backstage/search-page-panel/data-source.png';
import IconAiManage from 'src/assets/images/backstage/search-page-panel/ai-manage.png';
import IconBase from 'src/assets/images/backstage/search-page-panel/base.png';

import { useHistory } from 'react-router-dom';
import { useAppSelector } from 'src/hooks/hooks';
import { showRoute } from 'src/utils/route';
import { AppRoute } from 'src/types/Route';

const SearchPagePanelContainer = styled.div`
  @keyframes opacity {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
  overflow: hidden;
  z-index: 999;
  position: fixed;
  display: flex;
  justify-content: space-between;
  align-items: stretch;
  top: 55px;
  width: 100vw;
  height: fit-content;
  min-height: 320px;
  background: #fff;
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.08);
  animation: opacity 0.5s ease-in-out;
  .left {
    position: relative;
    width: 252px;
    background: rgb(243, 244, 246);
    padding: 48px 25px 0 70px;
    .title {
      width: 153px;
      color: #2e405d;
      font-size: 16px;
      line-height: 25px;
    }
    .text {
      margin-top: 14px;
      width: 153px;
      font-size: 12px;
      color: #909aaa;
      line-height: 25px;
    }
    .background {
      position: absolute;
      right: 0;
      bottom: 0;
      width: 144px;
      height: 200px;
    }
  }
  .right {
    flex: 1;
    padding: 24px;
    height: 100%;
    .custom-input {
      display: flex;
      margin-bottom: 16px;
      width: 380px;
      height: 32px !important;
      background: #f5f6f8;
      border: none;
      .ant-input {
        background: #f5f6f8 !important;
      }
      .ant-input-suffix {
        cursor: pointer;
      }
    }
    .module-list-wrapper {
      overflow: auto;
      height: calc(100% - 24px * 2);
      // scrollbar-width: none; /* firefox */
      // -ms-overflow-style: none; /* IE 10+ */
      // &::-webkit-scrollbar {
      //   display: none; /* Chrome Safari */
      // }
    }
  }
`;

const ModulePageWrapper = styled.div`
  ${({ theme }) => `
    .title {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      gap: 6px;
      padding: 6px 0;
      border-bottom: 1px solid #dcdcdc;
      .icon {
        width: 18px;
        height: 18px;
      }
      .text {
        color: #909aaa;
        font-size: 16px;
      }
    }
    .list {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      flex-wrap: wrap;
      gap: 24px;
      padding-top: 12px;
      padding-bottom: 6px;
      .item {
        color: #3b4b67;
        font-size: 15px;
        cursor: pointer;
        &:hover {
          color: ${theme.colors.primary.base};
        }
      }
    }
  `}
`;

const ModulePageList: React.FC<{
  icon: string;
  title: string;
  list: AppRoute[];
}> = ({ icon, title, list }) => {
  const history = useHistory();

  const clickItem = (item: AppRoute) => {
    // if (item.name === '角色列表') {
    //   location.assign(`/roles/list/`);
    //   return;
    // }
    localStorage.setItem('backstageSearchPanelVisible', 'false');
    window.dispatchEvent(new Event('storage'));
    history.push(item.path);
  };
  const render = () => {
    if (list.length === 0) return <></>;
    return (
      <ModulePageWrapper>
        <div className="title">
          <img src={icon} className="icon" />
          <div className="text">{title}</div>
        </div>
        <div className="list">
          {list.map(item => (
            <div
              className="item"
              key={item.name}
              onClick={() => clickItem(item)}
            >
              {item.name}
            </div>
          ))}
        </div>
      </ModulePageWrapper>
    );
  };
  return render();
};

const SearchPagePanel = () => {
  const [visible, setVisible] = useState(
    localStorage.getItem('backstageSearchPanelVisible') === 'true',
  );

  // 监听 localStorage 的变化
  useEffect(() => {
    const handleStorageChange = () => {
      setVisible(
        localStorage.getItem('backstageSearchPanelVisible') === 'true',
      );
    };

    window.addEventListener('storage', handleStorageChange);
    return () => {
      window.removeEventListener('storage', handleStorageChange);
    };
  }, []);

  const closePanel = () => {
    localStorage.setItem('backstageSearchPanelVisible', 'false');
    window.dispatchEvent(new Event('storage'));
  };

  // 点击面板以外的区域关闭面板
  const handleClickOutside = (e: PointerEvent) => {
    // @ts-ignore
    if (!e.target?.closest('.search-page-panel')) {
      closePanel();
    }
  };

  useEffect(() => {
    if (visible) {
      setModuleList(originModuleList); // 重新打开时重置数据
      document.addEventListener('click', handleClickOutside);
    } else {
      document.removeEventListener('click', handleClickOutside);
    }

    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, [visible]);

  const { behaviorKeys } = useAppSelector(state => state.behaviorReducer);

  // 页面原始数据
  const originModuleList = [
    {
      title: '用户管理',
      icon: IconUserPermission,
      list: userPermissionRoutes.filter(r => !r.hideInPanel),
    },
    {
      title: '数据权限',
      icon: IconDataPermission,
      list: dataPermissionRoutes.filter(r => !r.hideInPanel),
    },
    // {
    //   title: '日志审计',
    //   icon: IconLog,
    //   list: logRoutes.filter(r => !r.hideInPanel),
    // },
    {
      title: '数据源',
      icon: IconDataSource,
      list: dataSourceRoutes.filter(r => !r.hideInPanel),
    },
    {
      title: 'AI助手管理',
      icon: IconAiManage,
      list: aiManageRoutes.filter(r => !r.hideInPanel),
    },
    {
      title: '基础信息',
      icon: IconBase,
      list: baseRoutes.filter(r => !r.hideInPanel),
    },
  ]
    .map(route => {
      return {
        ...route,
        list: route.list.filter(v => showRoute(v, behaviorKeys)),
      };
    })
    .filter(route => route.list.length > 0);

  // 页面渲染数据
  const [moduleList, setModuleList] = useState(originModuleList);
  /**
   * 查询页面
   */
  const handleSearch: ChangeEventHandler<HTMLInputElement> = e => {
    const { value } = e.target;
    if (!value) {
      setModuleList(originModuleList); // 关键字为空时恢复原始数据
      return;
    }

    const filterList = originModuleList
      .map(module => ({
        ...module,
        list: module.list.filter(item => item.name?.includes(value)),
      }))
      .filter(module => module.list.length > 0);

    setModuleList(filterList);
  };

  const render = () => {
    if (!visible) return <></>;
    return (
      <SearchPagePanelContainer
        className="search-page-panel"
        onMouseLeave={closePanel}
      >
        <div className="left hidden lg:!block">
          <div className="title">后台管理</div>
          <div className="text">
            后台管理涵盖用户权限、日志审计、数据源配置、AI助手管理及基础信息设置，支持系统高效运行与安全管理
          </div>
          <img src={ImgBackground} className="background" />
        </div>
        <div className="right">
          <Input
            className="custom-input"
            placeholder="请输入您需要查看的页面"
            onChange={handleSearch}
            showSearch
          />
          <div className="module-list-wrapper">
            {moduleList.map((module, index) => (
              <ModulePageList
                key={module.title + index}
                title={module.title}
                icon={module.icon}
                list={module.list}
              />
            ))}
          </div>
        </div>
      </SearchPagePanelContainer>
    );
  };
  return render();
};

export default SearchPagePanel;
